var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 8,
    viewBox: "-0.45 -0.45 24 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,3.375 C15,5.240625 13.490625,6.75 11.625,6.75 C9.759375,6.75 8.25,5.240625 8.25,3.375 C8.25,1.509375 9.759375,0 11.625,0 C13.490625,0 15,1.509375 15,3.375 Z M19.875,0 C18.009375,0 16.5,1.509375 16.5,3.375 C16.5,5.240625 18.009375,6.75 19.875,6.75 C21.740625,6.75 23.25,5.240625 23.25,3.375 C23.25,1.509375 21.740625,0 19.875,0 Z M3.375,0 C1.509375,0 0,1.509375 0,3.375 C0,5.240625 1.509375,6.75 3.375,6.75 C5.240625,6.75 6.75,5.240625 6.75,3.375 C6.75,1.509375 5.240625,0 3.375,0 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsMore);
export default __webpack_public_path__ + "static/media/dots-more.01cd0405ec49eb08b6939045ef1e3250.svg";
export { ForwardRef as ReactComponent };